import Cookies from 'js-cookie'
import config from '../../config'

export const getKycById = async (id) => {
  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/kyc/${id}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  }).then((res) => res.json())

  if (response.status.code !== 0) throw new Error(response.status.description)

  return response.data
}
